// Module
var code = "Continuando la navigazione, si accetta l'uso di cookies per fornire i servizi e le offerte su misura per i tuoi interessi. Per ulteriori informazioni e per impostare i cookie. <a class=\"underline cursor-pointer\" data-cy=\"open-cookie-banner\" @click=\"updateModalConfig({ isOpen: true, modalComponent: 'CookiesModal' })\">Clicca qui</a>.";
// Exports
module.exports = code;